// Indian cities by state from country-state-city (comprehensive list)
import { City } from 'country-state-city';
import { getStateCodeByName } from './indianStates';

const INDIA_CODE = 'IN';

/**
 * Get all cities for an Indian state by state name.
 * @param {string} stateName - Full state name (e.g. "Tamil Nadu", "Maharashtra")
 * @returns {string[]} Array of city names
 */
export const getCitiesByState = (stateName) => {
  if (!stateName || typeof stateName !== 'string') return [];
  const stateCode = getStateCodeByName(stateName.trim());
  if (!stateCode) return [];
  const cities = City.getCitiesOfState(INDIA_CODE, stateCode);
  return (cities || []).map((c) => c.name).filter(Boolean).sort((a, b) => a.localeCompare(b));
};
